import React, {useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import { userService } from "../../services/user.service";
import {IoCheckmarkCircle} from "react-icons/io5";
import {Col, Form, Input, Row, Button} from "antd";
import "./resetPassword.scss";
import {ColorStripe} from "../../components/colorStripe/colorStripe";
import {MessageSuccess} from "../../components/messageSuccess/messageSuccess";

export const ResetPassword = (props) => {
  const [user, setUser] = useState({
    Email: '',
    Code: '',
    ConfirmPassword:'',
    password: '',
  });
  const history = useHistory();
  const [validatePassword, setValidatePassword] = useState(false);
  const oneCharacter = useRef();
  const oneN = useRef();
  const oneLetterL = useRef();
  const oneLetterU = useRef();
  const min8Characters = useRef();
  const [form] = Form.useForm();
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [passwordSaved, setPasswordSaved] = useState(false);

  const onSubmit = async () => {
    try {
      const queryParams = new URLSearchParams(props.location.search);

      const email = queryParams.get("email");
      const code = props.location.search.split("code=")[1];

      if (!email || !code) {
        console.error("Faltan parámetros de recuperación (email o código).");
        return;
      }

      const updatedUser = {
        ...user,
        Email: email,
        Code: code,
        ConfirmPassword: user.password,
      };

      const result = await userService.resetPassword(updatedUser);

      const isSuccess = result.responseCode === "00";
      setPasswordSuccess(true);
      setPasswordSaved(isSuccess);
    } catch (error) {
      console.error("Error al restablecer la contraseña:", error);
      setPasswordSuccess(true);
      setPasswordSaved(false);
    } finally {
      clearForm();
    }
  };

  const clearForm = () => {
    form.resetFields();
    setUser({
      Email: '',
      Code: '',
      ConfirmPassword:'',
      password: '',
    })
  }

  const handlePassword = (e) => {
    const oneLetterUppercase = /.*[A-Z].*/;
    const oneLetterLowercase = /.*[a-z].*/;
    const oneNumber = /.*[0-9].*/;
    const oneSpecialCharacter = /(.*[!@#$%\^&*(){}[\]<>?/|-]+|.*[!@#$%\^&*(){}[\]<>?/|\-]+)/;

    const noSpace = e.target.value.replace(/ /g,"");

    if(String(noSpace).length >= 8)
      min8Characters.current.className = 'success';
    else min8Characters.current.className = '';

    if(oneLetterUppercase.test(noSpace))
      oneLetterU.current.className = 'success';
    else oneLetterU.current.className = '';

    if(oneLetterLowercase.test(noSpace))
      oneLetterL.current.className = 'success'
    else oneLetterL.current.className = '';

    if(oneNumber.test(noSpace))
      oneN.current.className = 'success';
    else oneN.current.className = '';

    if(oneSpecialCharacter.test(noSpace))
      oneCharacter.current.className = 'success';
    else oneCharacter.current.className = '';

    form.setFieldValue('password',noSpace)
    setUser({...user, [e.target.name]: noSpace})
  }

  return (
      <section className={"reset-password__container"}>
         <div className={"reset-password__top"}>
           <h2>Cambia tu contraseña</h2>
           <ColorStripe />
         </div>
        <div className={"reset-password__content"}>

          {
            (passwordSuccess) ?
                <MessageSuccess
                    title={(passwordSaved) ? "Contraseña cambiada exitosamente" : "No se pudo actualizar tu Contraseña"}
                    description={(passwordSaved) ? "Se guardó tu nueva contraseña" : "Hubo un error al intentar guardar tu nueva contraseña"}
                    isSuccess={passwordSaved}
                    btnText={(passwordSaved) ? "Ir al home" : "Volver a intentar"}
                    handleButtonClick={() => {
                      if(passwordSaved) history.push("/");
                      else setPasswordSuccess(false);
                    }}
                />
                :
                <Form
                    className="form-light small"
                    onFinish={onSubmit}
                    layout={'vertical'}
                    form={form}
                >
                  <Row gutter={[32,0]}>
                    <Col xl={12} lg={12} md={24} sm={12} xs={24}>
                      <Form.Item
                          label={'Contraseña'}
                          htmlFor={'password'}
                          name={'password'}
                          rules={[
                            {
                              required: true,
                              message: '*Campo requerido'
                            },
                            {
                              min: 8,
                              message: ''
                            },
                            {
                              pattern: new RegExp(/.*[A-Z].*/),
                              message: ''
                            },
                            {
                              pattern: new RegExp(/.*[a-z].*/),
                              message: ''
                            },
                            {
                              pattern: new RegExp(/.*[0-9].*/),
                              message: ''
                            },
                            {
                              pattern: new RegExp(/(.*[!@#$%\^&*(){}[\]<>?/|-]+|.*[!@#$%\^&*(){}[\]<>?/|\-]+)/),
                              message: ''
                            },
                          ]}
                          onChange={handlePassword}
                      >
                        <Input.Password
                            name={'password'}
                            size={'large'}
                            onBlur={() => setValidatePassword(false)}
                            onFocus={() => setValidatePassword(true)}
                        />
                      </Form.Item>
                      <div className={`msg-password`}>
                        <ul className={'msg-password__list'}>
                          <li><span ref={min8Characters}><IoCheckmarkCircle /></span>Mínimo 8 carácteres</li>
                          <li><span ref={oneLetterU}><IoCheckmarkCircle /></span>1 letra mayúscula</li>
                          <li><span ref={oneLetterL}><IoCheckmarkCircle /></span>1 letra minúscula</li>
                          <li><span ref={oneN}><IoCheckmarkCircle /></span>1 número</li>
                          <li><span ref={oneCharacter}><IoCheckmarkCircle /></span>1 carácter especial</li>
                        </ul>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={24} sm={12} xs={24}>
                      <Form.Item
                          label={'Confirma tu contraseña'}
                          name={'confirmPassword'}
                          rules={[
                            {
                              required: true,
                              message: ''
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('¡Las contraseñas no coinciden!'));
                              },
                            }),
                          ]}
                      >
                        <Input.Password
                            name={'confirmPassword'}
                            size={'large'}
                            disabled={user.password === ''}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <div className="form-light__footer">
                    <Button
                        htmlType={'button'}
                        type={"default"}
                        onClick={() => history.push('/home')}
                        block={true}
                    >
                      Cancelar
                    </Button>
                    <Button htmlType={'submit'} type={'primary'} block={true}>Guardar nueva contraseña</Button>
                  </div>
                </Form>
          }
         </div>
      </section>
  );
}